var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path, _path2, _path3, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCulture04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458984,
    y: 0.826172,
    width: 350,
    height: 233,
    fill: "#2E9161"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.357,
    cy: 100.441,
    rx: 6.53888,
    ry: 6.51122,
    fill: "#F8CCA4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.286,
    cy: 82.0865,
    rx: 5.52789,
    ry: 5.50451,
    fill: "#F8CCA4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.897,
    cy: 89.862,
    rx: 7.80905,
    ry: 7.77601,
    fill: "#F8CCA4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.541,
    cy: 83.737,
    rx: 7.80905,
    ry: 7.77601,
    fill: "#F8CCA4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.223,
    cy: 77.1198,
    rx: 7.80905,
    ry: 7.77601,
    fill: "#F8CCA4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.011,
    cy: 101.694,
    rx: 12.9012,
    ry: 12.8466,
    fill: "#F8CCA4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.752,
    cy: 91.5122,
    rx: 11.4022,
    ry: 11.354,
    fill: "#F8CCA4"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.752,
    cy: 100.44,
    rx: 11.4022,
    ry: 11.354,
    fill: "#F8CCA4"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.289,
    cy: 84.895,
    rx: 11.4022,
    ry: 11.354,
    fill: "#F8CCA4"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.756,
    cy: 91.5123,
    rx: 7.80905,
    ry: 7.77601,
    fill: "#F8CCA4"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.034,
    cy: 104.302,
    rx: 11.6878,
    ry: 11.6384,
    fill: "#F8CCA4"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.319,
    cy: 99.2401,
    rx: 9.03024,
    ry: 8.99204,
    fill: "#F8CCA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.911 105.29C227.732 104.009 228.797 102.897 230.084 103.021L248.061 104.757L268.559 105.537L289.04 104.826L307.025 103.03C308.315 102.902 309.385 104.015 309.205 105.299L300.773 165.344H284.666H268.559H252.451H236.344L227.911 105.29Z",
    fill: "#FCD2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.912 105.228L236.344 165.344H252.451L248.059 104.755L230.092 102.96C228.802 102.831 227.732 103.944 227.912 105.228Z",
    fill: "#BD4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.559 165.344V105.536L289.059 104.755L284.666 165.344H268.559Z",
    fill: "#BD4848"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.931,
    cy: 95.797,
    rx: 4.35057,
    ry: 4.33217,
    fill: "#EBAC72"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.80712,
    cy: 2.23004,
    rx: 1.80712,
    ry: 2.23004,
    transform: "matrix(0.719103 0.694903 -0.697944 0.716152 253.607 89.0293)",
    fill: "#EBAC72"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.80712,
    cy: 2.23004,
    rx: 1.80712,
    ry: 2.23004,
    transform: "matrix(0.719103 0.694903 -0.697944 0.716152 247.332 95.9902)",
    fill: "#EBAC72"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.2921,
    cy: 3.30073,
    rx: 3.2921,
    ry: 3.30073,
    transform: "matrix(0.277634 -0.960687 0.96131 0.275468 251.947 97.6387)",
    fill: "#EBAC72"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.829,
    cy: 87.0104,
    rx: 3.27233,
    ry: 3.25848,
    fill: "#EBAC72"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.671,
    cy: 91.9282,
    rx: 4.38421,
    ry: 4.36566,
    fill: "#EBAC72"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.187,
    cy: 84.5404,
    rx: 4.12031,
    ry: 4.10288,
    fill: "#EBAC72"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.02,
    cy: 94.4083,
    rx: 2.86768,
    ry: 2.85555,
    fill: "#EBAC72"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.55,
    cy: 87.9778,
    rx: 5.00679,
    ry: 4.98561,
    fill: "#EBAC72"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture04);
export default __webpack_public_path__ + "static/media/culture_04.fc07bd4a10e2272630bef936633cb1fc.svg";
export { ForwardRef as ReactComponent };